import React from 'react';

const CryptoWallet = ({ wallet, qrCodeUrl, copiedAddress, onCopyAddress }) => {
  const isCopied = copiedAddress === wallet.address;

  return (
    <div className="bg-neutral-800/30 p-3 rounded-lg">
      <div className="flex items-center justify-between mb-2">
        <h4 className="text-white/90 text-sm font-medium">{wallet.currency}</h4>
        <img
          src={qrCodeUrl}
          alt={`${wallet.symbol} QR Code`}
          className="w-12 h-12 rounded border border-neutral-600/50"
        />
      </div>
      <div className="flex items-center gap-2">
        <div className="flex-1 bg-neutral-700/50 p-2 rounded text-white/80 text-xs font-mono break-all select-text">
          {wallet.address}
        </div>
        <button
          type="button"
          onClick={() => onCopyAddress(wallet.address, wallet.currency)}
          className="relative p-2 bg-emerald-600/20 hover:bg-emerald-600/30 rounded transition-colors group"
          title="Copy to clipboard"
        >
          {isCopied ? (
            <svg className="h-4 w-4 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          ) : (
            <svg className="h-4 w-4 text-white/60 group-hover:text-white/80" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
            </svg>
          )}
          {isCopied && (
            <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-green-500 text-white text-xs px-2 py-1 rounded whitespace-nowrap z-10">
              Copied!
            </div>
          )}
        </button>
      </div>
    </div>
  );
};

export default CryptoWallet;
